export default __webpack_public_path__ + "static/media/step5-a.f08b2d26.png";